/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { FetchHttpRequest } from './core/FetchHttpRequest';
import { BrewDatService } from './services/BrewDatService';
import { BrewingRecipesSettingsService } from './services/BrewingRecipesSettingsService';
import { BrewingSpecialsSettingsService } from './services/BrewingSpecialsSettingsService';
import { FeatureFlagsService } from './services/FeatureFlagsService';
import { GeneralSettingsService } from './services/GeneralSettingsService';
import { UsersService } from './services/UsersService';
type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;
export class UserProfileApiClient {
  public readonly brewDat: BrewDatService;
  public readonly brewingRecipesSettings: BrewingRecipesSettingsService;
  public readonly brewingSpecialsSettings: BrewingSpecialsSettingsService;
  public readonly featureFlags: FeatureFlagsService;
  public readonly generalSettings: GeneralSettingsService;
  public readonly users: UsersService;
  public readonly request: BaseHttpRequest;
  constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = FetchHttpRequest) {
    this.request = new HttpRequest({
      BASE: config?.BASE ?? '',
      VERSION: config?.VERSION ?? '1',
      WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
      CREDENTIALS: config?.CREDENTIALS ?? 'include',
      TOKEN: config?.TOKEN,
      USERNAME: config?.USERNAME,
      PASSWORD: config?.PASSWORD,
      HEADERS: config?.HEADERS,
      ENCODE_PATH: config?.ENCODE_PATH,
    });
    this.brewDat = new BrewDatService(this.request);
    this.brewingRecipesSettings = new BrewingRecipesSettingsService(this.request);
    this.brewingSpecialsSettings = new BrewingSpecialsSettingsService(this.request);
    this.featureFlags = new FeatureFlagsService(this.request);
    this.generalSettings = new GeneralSettingsService(this.request);
    this.users = new UsersService(this.request);
  }
}

